// extracted by mini-css-extract-plugin
module.exports = {"grid":"emails-log-grid_grid__1VOof"};